import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'Home',
  component: () => import('../views/Home')
},{
  path: '/login',
  name: 'Login',
  component: () => import('../views/Login')
}, {
  path: '/resetPassword',
  name: 'ResetPasswordPage',
  component: () => import('../views/ResetPasswordPage')
}, {
  path: '/area-list',
  component: () => import('../views/area/AreaListPage.vue')
}, {
  path: '/deviceList',
  name: 'deviceList',
  component: () => import('../views/DeviceList')
}, {
  path: '/myDeviceList',
  name: 'myDeviceList',
  component: () => import('../views/MyDeviceList')
}, {
  path: '/deviceView',
  name: 'deviceView',
  component: () => import('../views/DeviceView')
}, {
  path: '/deviceDayInfo',
  name: 'deviceDayInfo',
  component: () => import('../views/DeviceDayInfo')
}, {
  path: '/deviceDayInfoEdit',
  name: 'deviceDayInfoEdit',
  component: () => import('../views/DeviceDayInfoEdit')
}, {
  path: '/deviceUpdate',
  name: 'deviceUpdate',
  component: () => import('../views/DeviceUpdate')
}, {
  path: '/console',
  name: 'console',
  component: () => import('../views/Console')
}, {
  path: '/appVersionList',
  name: 'appVersionList',
  component: () => import('../views/AppVersionList')
}, {
  path: '/bootVersionList',
  name: 'bootVersionList',
  component: () => import('../views/BootVersionList')
}, {
  path: '/deviceManagerAssignment',
  name: 'deviceManagerAssignment.',
  component: () => import('../views/DeviceManagerAssignment')
}, {
  path: '/deviceSerialNumber',
  name: 'deviceSerialNumber',
  component: () => import('../views/DeviceSerialNumber')
}, {
  path: '/companyList',
  name: 'companyList',
  component: () => import('../views/CompanyList')
}, {
  path: '/companyEdit',
  name: 'companyEdit',
  component: () => import('../views/CompanyEdit')
}, {
  path: '/userList',
  name: 'userList',
  component: () => import('../views/UserList')
}, {
  path: '/userEdit',
  name: 'userEdit',
  component: () => import('../views/UserEdit')
}, {
  path: '/kwhPriceSetting',
  name: 'kwhPriceSetting',
  component: () => import('../views/KwhPriceSetting')
}, {
  path: '/workTimeReport',
  name: 'workTimeReport',
  component: () => import('../views/WorkTimeReport')
}, {
  path: '/savingPowerReport',
  name: 'savingPowerReport',
  component: () => import('../views/SavingPowerReport')
}, {
  path: '/deviceMonthInfo',
  name: 'deviceMonthInfo',
  component: () => import('../views/DeviceMonthInfo')
}, {
  path: '/menuManage',
  name: 'menuManage',
  component: () => import('../views/MenuManage')
}, {
  path: '/modbusTest',
  name: 'modbusTest',
  component: () => import('../views/ModbusTest')
}, {
  path: '/modifyPass',
  name: 'modifyPass',
  component: () => import('../views/ModifyPassPage.vue')
}, {
  path: '/example',
  name: 'example',
  component: () => import('../views/Example.vue')
},{
  path: '/roleList',
  component: () => import('@/views/RoleListPage')
},{
  path: '/roleEdit',
  component: () => import('@/views/RoleEditPage')
},{
  path: '/userRole',
  component: () => import('@/views/UserRolePage')
},{
  path: '/userComp',
  component: () => import('@/views/UserCompPage.vue')
},{
  path: '/deviceRunTotal',
  component: () => import('@/views/DeviceRunTotalList.vue')
}, {
  path: '/compDayReport',
  component: () => import('@/views/compDayReport.vue')
}, {
  path: '/deviceDayList',
  component: () => import('@/views/DeviceDayList.vue')
}, {
  path: '/compWeekList',
  component: () => import('@/views/CompWeekList.vue')
}, {
  path: '/hwProtocolVersionList',
  name: 'hwProtocolVersionList',
  component: () => import('@/views/hw-protocol/HwProtocolVersionList.vue')
}, {
  path: '/hwProtocolVersionEdit',
  name: 'hwProtocolVersionEdit',
  component: () => import('@/views/hw-protocol/HwProtocolVersionEdit.vue')
}]

const router = new VueRouter({
  //history地址不带#号，默认hash模式带#号
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
